import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdError } from 'react-icons/md';

export type ErrorType = 'clover' | 'task' | 'general';

interface ErrorModalProps {
  isVisible: boolean;
  title: string;
  message: string;
  type?: ErrorType;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  isVisible,
  title,
  message,
}) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
          role="alert"
          aria-live="assertive"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="relative max-w-md w-full mx-4"
          >
            {/* Error Card */}
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-md rounded-2xl p-8 border border-red-500/30 shadow-2xl">
              
              {/* Animated Error Icon */}
              <motion.div
                animate={{
                  scale: [1, 1.1, 1],
                  opacity: [0.8, 1, 0.8],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut',
                }}
                className="flex justify-center mb-6"
              >
                <div className="p-4 rounded-full bg-red-500/20 border-2 border-red-500/50">
                  <MdError className="w-12 h-12 text-red-500" />
                </div>
              </motion.div>

              {/* Title */}
              <h2 
                className="text-2xl font-bold text-white text-center mb-3"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {title}
              </h2>

              {/* Error Message */}
              <p 
                className="text-gray-300 text-center leading-relaxed"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {message}
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ErrorModal;
